<template>
  <a-tooltip title="批量删除">
    <a-button v-tc="{ name: '批量删除' }" type="danger" icon="delete" @click="onbatchDelete" />
  </a-tooltip>
</template>
<script>
import { caseBatchDelete } from '@/api/project/case';
export default {
  props: {
    checked: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      projectId: parseInt(this.$route.params.project_id) || null
    };
  },
  methods: {
    // 点击批量删除
    onbatchDelete() {
      if (this.checked.length > 0) {
        // 删除用例
        const self = this;
        this.$confirm({
          title: '确认',
          content: '确认要批量删除所选用例吗',
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk() {
            caseBatchDelete({ case_ids: self.checked, project_id: self.projectId }).then(() => {
              self.$emit('close');
              self.$message.success('删除成功');
            });
          }
        });
      } else {
        this.$message.warning('请选择需要操作的用例');
      }
    }
  }
};
</script>
